import { getPlayer } from "@/api/privateRequests/players/getPlayer";
import { playersSelector } from "@/redux/players/playersSlice";
import {
  fetchSbcSet,
  fetchSbcs,
  getSbcSetSelector,
  getSbcsSelector,
} from "@/redux/sbcs/sbcsSlice";
import { AppDispatch } from "@/redux/store";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { DetailedPlayerType } from "../DetailedPlayer/DetailedPlayer";
import SBCPageAsContentPost from "./SBCPageAsContentPost";

export type ContentPlayer = DetailedPlayerType & {
  playStyles: number[];
  playStylesPlus: number[];
  metaRatingsZeroChem: {
    [key: string]: number;
  };
};

export const SBCPageAsContentPostDataWrapper = () => {
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const sbcSet = useSelector(getSbcSetSelector(+id));
  const { sbcs } = useSelector(getSbcsSelector);
  const [player, setPlayer] = useState<ContentPlayer | null>(null);
  const { playerRoles } = useSelector(playersSelector);

  useEffect(() => {
    const fetchData = async () => {
      dispatch(fetchSbcs({ setId: +id }));
      await dispatch(fetchSbcSet({ setId: +id }));
    };
    fetchData();
  }, [id]);

  useEffect(() => {
    if (sbcSet?.reward?.resourceId) {
      getPlayer({
        resourceId: sbcSet.reward.resourceId,
        playerRoleId: sbcSet.reward.metaRating?.playerRoleId,
      }).then((player) => {
        setPlayer({
          ...player,
          resourceId: sbcSet.reward.resourceId,
          playerRoleId: sbcSet.reward.metaRating?.playerRoleId,
          playStyles: player.playStyles,
          playStylesPlus: player.playStylesPlus,
          metaRatingsZeroChem: {}, // TODO FIX
        });
      });
    }
  }, [sbcSet]);

  if (!player?.metaRatingsZeroChem || !player?.metaRatings) return <></>;

  return (
    <></>
    // <SBCPageAsContentPost
    //   player={player}
    //   sbcSet={sbcSet}
    //   sbcs={sbcs}
    //   playerRoles={playerRoles}
    // />
  );
};
